/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import Word from 'saur_ui_library/src/Atoms/Word/Word';
import { dateFr } from '../../utils/helper';
import {
  anyMeasuresFindForPiezometrySelected,
  datesFormatedForRequest,
  inputTextDate,
  piezometersDropdownlistComponent,
  radioButtonComponent,
  renderSwitchButtons,
  savePiezoParameter,
  warningMessageCss,
} from '../../utils/helpers/view/detailsHelper';
import { createGlobalStyle } from 'styled-components';
import ModernDatePicker from '../../components/common/component/ModernDatePicker';
import Button from 'saur_ui_library/src/Atoms/Input/Button/Button';
import EcpDetailBodyContainer from './EcpDetailBodyContainer';
import ActiveSurfaceChart from './ActiveSurfaceChart';
import { EcpDetailApi, PiezometryApi } from '../../utils/api';
import { fetchPov } from '../DetailHelper';
import {
  calculatePartsForPieGraphic,
  createDateForMonthlyGraphic,
  dataGroupedByTypeOrDate,
  formatedDataForDailyAndMonthlyGraphics,
  formatedPluvioDataForDailyAndMonthlyGraphics,
  getEcpMode,
  getUniqueTypeValues,
  initDates,
  isStepMode,
  normalizeStepReferenceFlow,
  parsePiezoMeasureDate,
  prepareTableData,
  sum,
  sumByType,
} from '../../utils/helpers/view/ecpDetailHelper';
import { piezoPluvioInterface } from '../H2SParam/Interface';
import { getPiezoIds, getPiezoParameter, verifyPluvioAndPiezoData } from '../../utils/helpers/view/prMrDetailHelper';
import { Toast } from 'primereact/toast';

type TabKey = 'limitPoint' | 'collectionPool' | 'activeSurface';

interface TabState {
  limitPoint: { label: string; active: boolean };
  collectionPool: { label: string; active: boolean };
  activeSurface: { label: string; active: boolean };
}

interface ECPDetailProps {
  row: any;
  IsVisible: boolean;
}

const ECPDetail = (props: ECPDetailProps) => {
  const [pluvioStatus, setPluvioStatus] = useState(false);
  const [piezoStatus, setPiezoStatus] = useState(false);
  // datepicker
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  // show or hide tabs - key-based model
  const [tabsStates, setTabsStates] = useState<TabState>({
    limitPoint: { label: 'Au point limite', active: true },
    collectionPool: { label: 'Bassin de collecte', active: false },
    activeSurface: { label: 'Surface active', active: false },
  });
  // STEP reference flow (only used in STEP mode)
  const [stepReferenceFlow, setStepReferenceFlow] = useState<number | null>(null);
  // data for line and histogramme charts
  const [dailyLimitPointData, setDailyLimitPointData] = useState<any>(null);
  const [monthlyLimitPointData, setMonthlyLimitPointData] = useState<any>(null);
  const [dailyCollectionPoolData, setDailyCollectionPoolData] =
    useState<any>(null);
  const [monthlyCollectionPoolData, setMonthlyCollectionPoolData] =
    useState<any>(null);
  // pluvio data
  const [pluvioMonthlyData, setMonthlyPluvioData] = useState<any>([]);
  const [pluvioDailyData, setDailyPluvioData] = useState<any>([]);
  // piezo data
  const [piezoDailyData, setDailyPiezoData] = useState<any>([]);
  // data for pie chart
  const [pieLimitPointData, setLimitPointPieData] = useState<any>(null);
  const [pieCollectionPoolData, setCollectionPoolPieData] = useState<any>(null);
  // data for tables
  const [tableLimitPointData, setLimitPointTableData] = useState<any>(null);
  const [tableCollectionPoolData, setCollectionPoolTableData] =
    useState<any>(null);
  // data for ihm
  const [dataSelected, setDataSelected] = useState<any>(piezoPluvioInterface.filter((p) => p.id === 3)[0]);
  const [dataToAdd, setDataToAdd] = useState<any>(piezoPluvioInterface);
  const [showFilters, setShowFilters] = useState<boolean>(false);
  const [piezoSelected, setPiezoSelected] = useState<any>(null);
  const [piezoOptions, setPiezoOptions] = useState<any>(null);
  const [piezoParameter, setPiezoParameter] = useState<any>(null);
  // pluvie value
  const [pluvieValue, setPluvieValue] = useState<any>([]);
  const [idPov, setIdPov] = useState<string | null>(null);
  // toast
  const toastSucess = useRef<any>(null);
  const toastError = useRef<any>(null);
  // cache for the piezometer station list (/57/query), not linked to the selected period, so it must not be refetched on each "Rechercher" click
  const piezoListItemsRef = useRef<any[] | null>(null);
  const piezoListItemsCodeRef = useRef<string | null>(null);

  const dailyDataLimitPoint = async (pRow: any, dates: any) => {
    let data: any = [],
      typeValues: any = [],
      dateValues: any = [],
      dataGroupedByDate: any = [],
      dataToShow: any = [];
    try {
      const response = await EcpDetailApi.getWaterDailyDataAtLimitPoint(
        pRow.Code,
        dates.startDate,
        dates.endDate,
      );
      data = formatedDataForDailyAndMonthlyGraphics(response.data);
      typeValues = getUniqueTypeValues(data.filter((d: any) => d.y !== null), 'type');
      dateValues = getUniqueTypeValues(data, 'x');
      dataGroupedByDate = dataGroupedByTypeOrDate(
        dateValues,
        data,
      );
      dataToShow = sumByType(dataGroupedByDate, typeValues);
    } catch (e) {
      console.log('erreur', e);
    }
    setDailyLimitPointData(dataToShow);
    setMonthlyLimitPointData(createDateForMonthlyGraphic(data, typeValues));
  };

  const getPercentageDataAtLimitPoint = async (pRow: any, dates: any) => {
    let tableData: any = [],
      dataToShow: any = [];
    try {
      const response = await EcpDetailApi.getPercentageDataAtLimitPoint(
        pRow.Code,
        dates.startDate,
        dates.endDate,
      );
      dataToShow = calculatePartsForPieGraphic(response.data);
      tableData = prepareTableData(dataToShow);
      setPluvieValue(dataToShow.filter((d) => d.type === 'PLUVIO'));
      setLimitPointPieData(
        dataToShow.filter((x) => x.type !== 'VTOT' && x.type != 'PLUVIO' && x.value > 0),
      );
    } catch (e) {
      console.log('erreur', e);
      setLimitPointPieData([]);
    }
    setLimitPointTableData(tableData);
  };

  const dailyPluvioData = async (pRow: any, dates: any) => {
    let dataToShow: any = [],
      dataDateFormated: any = [],
      dateDateFormatedValues: any = [],
      sumByTypeForMonthlyData: any = [];
    try {
      const response = await EcpDetailApi.getDailyPluvioDataAtLimitPoint(
        pRow.Code,
        dates.startDate,
        dates.endDate,
      );
      dataToShow = formatedPluvioDataForDailyAndMonthlyGraphics(
        response.data,
      );
      dataDateFormated = dataToShow.map((d: any) => { return { ...d, dateFormated: new Date(d.x).toLocaleDateString('fr').slice(3) }});
      dateDateFormatedValues = getUniqueTypeValues(dataDateFormated, 'dateFormated');
      sumByTypeForMonthlyData = dateDateFormatedValues.map((date: any) => {
        let dataByType: any = dataDateFormated.filter((d) => date === d.dateFormated);
        if (dataByType.length !== 0) {
          return {
            ...dataByType[0],
            y: sum(dataByType, "y"),
            x: new Date(
              dataByType[0].dateFormated.split("/")[1],
              Number(dataByType[0].dateFormated.split("/")[0] - 1)
            ),
          };
        }
      });
    } catch (e) {
      console.log('erreur', e);
    }
    setDailyPluvioData(dataToShow);
    setMonthlyPluvioData(sumByTypeForMonthlyData);
    setPluvioStatus(true);
  };

  const dailyPiezoData = async (pCodes: string, dates: any, pPiezoCarto: any[]) => {
    let piezoList: any = [],
      piezoOptions: any = [];
    try {
      const response = await PiezometryApi.getMeasures(
        pCodes,
        dates.startDate,
        dates.endDate,
      );
      // prepare data for graphics
      if (response.status === 200 && response.data.length > 0) {
        piezoList  = response.data.reduce((acc, item) => {
          const measures = item.measures.map((d) => ({
            x: parsePiezoMeasureDate(d.date),
            y: parseFloat(d.value),
            type: 'PIEZO',
          }));
          if (measures.length > 0) {
            acc.push({ code: item.code, measures });
          } else {
            acc.push({ code: item.code, measures: [] });
          }
          return acc;
        }, []);
        // keep order of piezoCarto data
        pPiezoCarto.forEach((p: any, i: number) => {
          piezoOptions.push( { 
            id: i, 
            label: p.WaterTableStationCode + ' (' + p.Distance.toLocaleString() + 'm)', 
            value: p.WaterTableStationCode 
          });
          if(piezoList.find((piezo) => piezo.code === p.WaterTableStationCode) === undefined){
            piezoList.push({ code: p.WaterTableStationCode, measures: [] });
          }
        });
      }
    } catch (e) {
      console.log('erreur', e);
    }
    setDailyPiezoData(piezoList);
    setPiezoOptions(piezoOptions);
    setPiezoStatus(true);
  };

  const dailyDataCollectionPool = async (pRow: any, dates: any) => {
    let data: any = [],
      typeValues: any = [],
      dateValues: any = [],
      dataGroupedByDate: any = [],
      dataToShow: any = [];
    try {
      const response = await EcpDetailApi.getWaterDailyDataCollectionPool(
        pRow.collectionPoolId,
        dates.startDate,
        dates.endDate,
      );
      data = formatedDataForDailyAndMonthlyGraphics(
        response.data,
      );
      typeValues = getUniqueTypeValues(data.filter((d: any) => d.y !== null), 'type');
      dateValues = getUniqueTypeValues(data, 'x');
      dataGroupedByDate = dataGroupedByTypeOrDate(
        dateValues,
        data,
      );
      dataToShow = sumByType(dataGroupedByDate, typeValues);
    } catch (e) {
      console.log('erreur', e);
    }
    setDailyCollectionPoolData(dataToShow);
    setMonthlyCollectionPoolData(createDateForMonthlyGraphic(data, typeValues));
  };

  const getPercentageDataCollectionPool = async (pRow: any, dates: any) => {
    let tableData: any = [],
      dataToShow: any = [];
    try {
      const response = await EcpDetailApi.getPercentageDataCollectionPool(
        pRow.collectionPoolId,
        pRow.Code,
        dates.startDate,
        dates.endDate,
      );
      dataToShow = calculatePartsForPieGraphic(
        response.data,
      );
      tableData = prepareTableData(dataToShow);
      setCollectionPoolPieData(
        dataToShow.filter((x) => x.type !== 'VTOT' && x.type != 'PLUVIO' && x.value > 0),
      );
    } catch (e) {
      console.log('erreur', e);
      setCollectionPoolPieData([]);
    }
    setCollectionPoolTableData(tableData);
  };

  const getDataForGraphics = async (pRow: any, dates: any, pluvioDates: any) => {
    const ecpMode = getEcpMode();
    
    // Always fetch limit point data
    dailyDataLimitPoint(pRow, dates);
    dailyPluvioData(pRow, pluvioDates);
    getPercentageDataAtLimitPoint(pRow, dates);
    
    // Skip collection pool fetches in STEP mode
    if (ecpMode !== 'step') {
      dailyDataCollectionPool(pRow, dates);
      getPercentageDataAtLimitPoint(pRow, dates).then(() => {
        getPercentageDataCollectionPool(pRow, dates);
      });
    }
    
    // Fetch STEP reference flow in STEP mode only
    if (ecpMode === 'step') {
      try {
        const refFlowResponse = await EcpDetailApi.getStepReferenceFlow(
          pRow.Code,
        );
        // STEP should always have a reference flow line; default to 0 when value is missing.
        const refFlowValue =
          refFlowResponse.data?.referenceFlow ??
          refFlowResponse.data?.VECSRef ??
          0;
        const normalized = normalizeStepReferenceFlow(refFlowValue);
        setStepReferenceFlow(normalized !== null && normalized >= 0 ? normalized : 0);
      } catch (e: any) {
        if (e?.response?.status !== 404) {
          console.warn('Failed to fetch STEP reference flow:', e);
        }
        setStepReferenceFlow(0);
      }
    }
    
    // Fetch piezometry station list (cached per site: not linked to the selected period)
    const applyPiezoListItems = (piezoListItems: any[]) => {
      if(piezoListItems.length > 0) {
        dailyPiezoData(piezoListItems.map((p) => p.attributes.WaterTableStationCode).join(","), dates, piezoListItems.map((p: any) => p.attributes));
      } else {
        setDailyPiezoData([]);
        setPiezoOptions([]);
        setPiezoStatus(true);
      }
    };
    if (piezoListItemsCodeRef.current === pRow.Code && piezoListItemsRef.current !== null) {
      applyPiezoListItems(piezoListItemsRef.current);
    } else {
      getPiezoIds(pRow.Code).then((piezoListItems) => {
        piezoListItemsRef.current = piezoListItems;
        piezoListItemsCodeRef.current = pRow.Code;
        applyPiezoListItems(piezoListItems);
      });
    }
    getPiezoParameter(pRow.Code).then((piezoParameter) => {
      if(piezoParameter !== undefined) {
        setPiezoParameter(piezoParameter);
        setPiezoSelected(piezoParameter.bssId === null ? null : piezoParameter.bssId);
      }
    });
  };

  useEffect(() => {
    // Handle STEP mode tab visibility changes
    if (isStepMode()) {
      // In STEP mode, only show limit point tab and deactivate others
      setTabsStates((prev) => ({
        limitPoint: { ...prev.limitPoint, active: true },
        collectionPool: { ...prev.collectionPool, active: false },
        activeSurface: { ...prev.activeSurface, active: false },
      }));
    }
  }, []);

  useEffect(() => {
    initDates().then((dates) => {
      setStartDate(dates.start);
      setEndDate(dates.end);
      const datesFormated = datesFormatedForRequest(dates.start, dates.end);
      getDataForGraphics(
        props.row,
        datesFormated.dataDates,
        datesFormated.pluvioDates,
      );
    });
    fetchPov(props.row.Code).then((pov) => setIdPov(pov));
  }, []);

  useEffect(() => {
    if (pluvioStatus === true && piezoStatus === true) {
      setPluvioStatus(false);
      setPiezoStatus(false);
      // manage filters
      const updateFilters = verifyPluvioAndPiezoData(pluvioDailyData, piezoDailyData);
      setDataToAdd(updateFilters.interfaceValues);
      setShowFilters(updateFilters.showHideFilters);
    }
  }, [pluvioStatus, piezoStatus]);

  const launchRequests = () => {
    if (startDate !== null && endDate !== null) {
      // show loaders
      setDailyCollectionPoolData(null);
      setDailyLimitPointData(null);
      setMonthlyCollectionPoolData(null);
      setMonthlyLimitPointData(null);
      setDailyPluvioData(null);
      setMonthlyPluvioData(null);
      setDailyPiezoData(null);
      setLimitPointPieData(null);
      setCollectionPoolPieData(null);
      setLimitPointTableData(null);
      setCollectionPoolTableData(null);
      setStepReferenceFlow(null);
      setShowFilters(false);
      setDataToAdd(piezoPluvioInterface);
      setPiezoSelected(null);
      setPiezoOptions(null);
      setPluvieValue([]);
      setDataSelected(piezoPluvioInterface.filter((p) => p.id === 3)[0]);
      const dates = datesFormatedForRequest(startDate, endDate);
      getDataForGraphics(props.row, dates.dataDates, dates.pluvioDates);
    }
  };

  return (
    <> 
      <Styles />
      <Toast id='toast-success' ref={toastSucess} />
      <Toast id='toast-error' ref={toastError} />
      {/* Menu */}
      <div
        style={{
          display: 'inline-flex',
          alignItems: 'flex-start',
          width: '100%',
          height: 'auto',
          marginBottom: '8px',
        }}
      >
        {/* date pickers */}
        {<div style={{ display: tabsStates.activeSurface.active === false ? 'contents' : 'none' }}>
            <div className='ecpDateSearchBlock'>
              <div className='ecpDateSearchInputs'>
                <div className='ecpDateInputGroup'>
                  <Word value='Mois de début' />
                  <ModernDatePicker
                    className='datePickFrom ecpDatePickInput'
                    inputPlaceholder='Mois de début'
                    value={startDate}
                    shouldHighlightWeekends
                    formatInputText={() => {
                      return inputTextDate(startDate);
                    }}
                    locale={dateFr}
                    onChange={(date: any) => {
                      setStartDate(date);
                    }}
                  />
                </div>
                <div className='ecpDateInputGroup'>
                  <Word value='Mois de fin' />
                  <ModernDatePicker
                    className='datePickFrom ecpDatePickInput'
                    inputPlaceholder='Mois de fin'
                    value={endDate}
                    shouldHighlightWeekends
                    formatInputText={() => {
                      return inputTextDate(endDate);
                    }}
                    locale={dateFr}
                    onChange={(date: any) => {
                      setEndDate(date);
                    }}
                  />
                </div>
              </div>
              {/* Search data */}
              <Button className={'button'} mode='basic' onClick={launchRequests}>
                <Word
                  variant='span'
                  textStyle='normalBold'
                  value={'Rechercher'}
                />
              </Button>
            </div>
            
            <div className='ecpInfoControlsRow'>
              {/* POV + Piezometers group */}
              <div className='ecpPovPiezoGroup'>
                {idPov && (
                  <div className='ecpPovBadge'>
                    <Word
                      className='ecpPovLabel'
                      textStyle='normalReg'
                      variant='span'
                      value='POV :'
                    />
                    <div className='ecpPovValueField'>
                      <Word
                        className='ecpPovValue'
                        variant='span'
                        textStyle='normalBold'
                        value={idPov.toString()}
                      />
                    </div>
                  </div>
                )}

                <div className='ecpPiezoActionCard'>
                  {piezometersDropdownlistComponent(piezoOptions, piezoSelected, setPiezoSelected, warningMessageCss, piezoDailyData !== null ? anyMeasuresFindForPiezometrySelected(piezoDailyData, piezoSelected) : false)}
                  {piezoOptions !== null && piezoOptions.length > 0 &&
                    <Button automatedTestId="button-submit" className="export-btn" onClick={() => savePiezoParameter(piezoSelected, piezoParameter, setPiezoParameter, toastSucess, toastError)} mode="plain">
                      <Word variant="span" textStyle="normalBold" value="Paramétrer" />
                    </Button>}
                </div>
              </div>

              {/* radio buttons */}
              <div className='ecpRadioCard'>
                <Word
                  className='ecpRadioLabel'
                  textStyle='normalReg'
                  variant='span'
                  value='Afficher graphe :'
                />
                <div className='ecpRadioContent'>
                  {radioButtonComponent(showFilters, dataToAdd, setDataSelected, warningMessageCss)}
                </div>
              </div>
            </div>

          </div>
        }

        <div
          style={{
            display: 'inline-flex',
            width: '100%',
            justifyContent: 'end',
          }}
        >
          {/* switch buttons - only show in PR mode */}
          {getEcpMode() === 'pr' && (() => {
            // Convert object-based tabsStates to array format expected by renderSwitchButtons
            const tabsArray = [
              { id: 0, label: tabsStates.limitPoint.label, active: tabsStates.limitPoint.active },
              { id: 1, label: tabsStates.collectionPool.label, active: tabsStates.collectionPool.active },
              { id: 2, label: tabsStates.activeSurface.label, active: tabsStates.activeSurface.active },
            ];
            
            // Create a wrapper setter that converts array back to object format
            const arrayToObjectSetter = (tabsArray: any[]) => {
              setTabsStates({
                limitPoint: { ...tabsStates.limitPoint, active: tabsArray[0].active },
                collectionPool: { ...tabsStates.collectionPool, active: tabsArray[1].active },
                activeSurface: { ...tabsStates.activeSurface, active: tabsArray[2].active },
              });
            };
            
            return renderSwitchButtons(tabsArray, arrayToObjectSetter);
          })()}
        </div>
      </div>
      {tabsStates.activeSurface.active === false && <EcpDetailBodyContainer
        showTab={tabsStates.collectionPool.active === true ? tabsStates.collectionPool.active : tabsStates.limitPoint.active}
        dailyData={tabsStates.collectionPool.active === true ? dailyCollectionPoolData : dailyLimitPointData}
        pluvioDailyData={pluvioDailyData}
        piezoCode={piezoSelected}
        piezoDailyData={piezoDailyData}
        monthlyData={tabsStates.collectionPool.active === true ? monthlyCollectionPoolData : monthlyLimitPointData}
        pluvioMonthlyData={pluvioMonthlyData}
        pieData={tabsStates.collectionPool.active === true ? pieCollectionPoolData : pieLimitPointData}
        tableData={tabsStates.collectionPool.active === true ? tableCollectionPoolData : tableLimitPointData}
        dataSelected={dataSelected}
        tabType={tabsStates.collectionPool.active === true ? 'collectionPool' : 'limitPoint'}
        stepReferenceFlow={stepReferenceFlow}
        chartStartDate={startDate}
        chartEndDate={endDate}
      />}
      {/* Active surface chart  */}

      {tabsStates.activeSurface.active === true && (
        <ActiveSurfaceChart
          showTab={tabsStates.activeSurface.active}
          collectionPoolId={props.row.collectionPoolId}
        />
      )}
      <br />
    </>
  );
};

const Styles = createGlobalStyle`
.sds-reset-style{
  .loaderEcpGraphics {
    width: 48px;
    height: 48px;
    border: 5px solid #FFF;
    border-bottom-color: #243977;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    }

    @keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
  }
  .button {
    color: #232323;
    background-color: #63d1b5;
    font-size: 14px;
    line-height: 22px;
    text-align: center;
    border-radius: 25px;
    cursor: pointer;
    padding: 10px 20px;
  }
  .ecpVolTable {
    td:first-child {
      font-weight: bolder;
    }
    tr:last-child, tr:first-child {
      font-weight: bolder;
    }
    td {
      padding: 5px;
    }
    td:nth-child(3), td:nth-child(4) {
      text-align: right;
    }
  }

  .ecpDatePickInput {
    .my-custom-input {
      background-color: #ffffff !important;
      border-color: #ffffff !important;
      width: 180px !important;
      min-width: 180px !important;
      max-width: 180px;
      height: 36px !important;
      line-height: 36px !important;
    }
  }

  .ecpDateSearchBlock {
    display: inline-flex;
    align-items: flex-end;
    gap: 20px;
    padding: 8px 12px;
    background: #edf2fa;
    border-radius: 0;

    .sds-m-modern-date-picker {
      margin-bottom: 2px !important;
    }
  }

  .ecpDateSearchInputs {
    display: inline-flex;
    gap: 10px;
  }

  .ecpDateInputGroup {
    display: block;
  }

  .ecpDateSearchBlock .button {
    margin-bottom: 6px;
  }

  .ecpInfoControlsRow {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    margin-left: 50px;
    flex-wrap: nowrap;
    padding: 0 12px 8px !important;
    background: transparent;
    border-radius: 0;
  }

  .ecpPovBadge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
    padding: 0;
    min-height: auto;
    border-radius: 0;
    border: 0;
    background: transparent;
    box-shadow: none;
  }

  .ecpPovPiezoGroup {
    display: inline-flex;
    align-items: center;
    gap: 24px;
    padding: 8px 12px;
    min-height: 34px;
    border-radius: 0;
    border: 0;
    background: #edf2fa;
  }

  .ecpPovBadge .sds-word {
    display: inline !important;
    line-height: 1.2 !important;
  }

  .ecpPovLabel {
    display: inline !important;
    color: #3f5475 !important;
    white-space: nowrap;
  }

  .ecpPovValue {
    display: inline !important;
    color: #232323 !important;
    white-space: nowrap;
    font-weight: 400 !important;
  }

  .ecpPovValueField {
    display: inline-flex;
    align-items: center;
    min-height: 34px;
    padding: 7px 10px;
    border: 1px solid transparent;
    background: #ffffff;
    border-radius: 0;
    line-height: 1;
  }

  .ecpRadioCard {
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    align-self: stretch;
    max-width: none;
    padding: 8px 12px;
    min-height: 34px;
    border-radius: 0;
    border: 0;
    background: #edf2fa;
  }

  .ecpRadioLabel {
    color: #3f5475 !important;
    white-space: nowrap;
    margin-right: 10px;
  }

  .ecpRadioContent {
    flex: 1;
    min-width: 0;
  }

  .ecpRadioCard > div {
    width: 100%;
  }

  .ecpRadioCard .mesure-radiolist {
    width: 100%;
    justify-content: space-evenly;
    align-items: flex-start !important;
    gap: 12px;
  }

  .ecpRadioCard .mesure-radiolist .radio-item {
    flex: 1 1 0 !important;
    display: flex;
    align-items: center;
    justify-content: center;
    align-self: center !important;
    margin-bottom: 0 !important;
    padding: 0 6px;

    .radio-item-label {
      margin-left: 5px !important;
    }
  }

  .ecpRadioCard .sds-radio-item {
    display: inline-flex !important;
    align-items: center !important;
  }

  .ecpPiezoActionCard {
    display: inline-flex;
    align-items: center;
    gap: 12px;
    padding: 0;
    min-height: 34px;
    border: 0;
    background: transparent;
  }

  .ecpPiezoActionCard .dropdownlist-container {
    margin-top: 0 !important;
    min-width: 250px;
    flex-direction: row !important;
    align-items: flex-start;
    gap: 6px;
    flex-direction: column !important;
  }

  .ecpPiezoActionCard .dropdownlist-container .piezo-main-line {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    white-space: nowrap;
  }

  .ecpPiezoActionCard .dropdownlist-container .MuiTypography-root {
    margin-right: 0 !important;
    font-size: 14px;
    color: #3f5475;
  }

  .ecpPiezoActionCard .dropdownlist-container .MuiInputLabel-root {
    display: none !important;
  }

  .ecpPiezoActionCard .dropdownlist-container .MuiFormControl-root {
    min-width: 250px !important;
  }

  .ecpPiezoActionCard .dropdownlist-container .MuiOutlinedInput-root {
    border-radius: 0;
    background: #ffffff;
    min-height: 40px;
  }

  .ecpPiezoActionCard .dropdownlist-container .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline {
    border-color: #c7d8ef;
  }

  .ecpPiezoActionCard .dropdownlist-container .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #69b5db;
    border-width: 1px;
  }

  .ecpPiezoActionCard .dropdownlist-container .MuiOutlinedInput-notchedOutline legend {
    max-width: 0;
  }

  .ecpPiezoActionCard .dropdownlist-container .MuiSelect-select {
    padding: 9px 34px 9px 10px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    color: #232323;
  }

  .ecpPiezoActionCard .export-btn {
    margin-bottom: 0;
  }
}
`;

export default ECPDetail;
